"use client";

import { c as _c } from "react/compiler-runtime";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { AgenciesButton } from "@website/widget/header/components/agencies/agencies-button";
import { BackButton } from "@website/widget/header/components/back/back-button";
import { Logo } from "@website/widget/header/components/logo/logo";
import { MyTrips } from "@website/widget/header/components/my-trips/my-trips";
import { SupportAgent } from "@website/widget/header/components/support-agent/support-agent";
import { TravelServicesMobileDrawer } from "@website/widget/header/components/travel-services/TravelServicesMobileDrawer";
import { TravelServicesDesktop } from "@website/widget/header/components/travel-services/travel-services-desktop";
import { HeaderLogin } from "@website/widget/header/header-login/header-login";
import { HeaderPropertiesType } from "@website/widget/header/header.types";
import { LoginModal } from "@website/widget/login";
import { Suspense } from "react";
import { SnappIrTravelServicesDesktop } from "./components/travel-services/Snapp-ir-travel-services-desktop";
import { SnappIrTravelServicesMobileDrawer } from "./components/travel-services/SnappIrTravelServicesMobileDrawer";
export const Header = t0 => {
  const $ = _c(48);
  const {
    showBackButton: t1,
    isHomePage: t2,
    minimalView,
    hideBackButton,
    title,
    customTitle,
    minimalLogo,
    disableLogoURL: t3
  } = t0;
  const showBackButtonParameter = t1 === undefined ? false : t1;
  const isHomePage = t2 === undefined ? false : t2;
  const disableLogoURL = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = isChannel(["jek"]);
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const isJek = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = isChannel(["jek"]);
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const isAndroidOrWebApp = t5;
  const showBackButton = !hideBackButton && (showBackButtonParameter || isJek || isAndroidOrWebApp && !isHomePage);
  const showAppModeTitle = (isJek || isAndroidOrWebApp) && Boolean(title);
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = isChannel(["b2b", "website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const showAuth = t6;
  let t7;
  if ($[3] !== isHomePage) {
    t7 = !isChannel(["in-store"]) && isHomePage;
    $[3] = isHomePage;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const showSupportAgent = t7;
  let t8;
  if ($[5] !== minimalView) {
    t8 = !minimalView && isChannel(["website"]);
    $[5] = minimalView;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const showAgenciesButton = t8;
  let t9;
  if ($[7] !== minimalView) {
    t9 = !minimalView && isChannel(["website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[7] = minimalView;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const showMyTrips = t9;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = process.env.CHANNEL === "snapp-ir-hotel" || getOrigin() === "https://hotel.snapp.ir";
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const isSnappHotel = t10;
  let t11;
  if ($[10] !== minimalView) {
    t11 = !minimalView && isChannel(["website", "telesale", "web-app", "android", "safarmarket"]);
    $[10] = minimalView;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const showTravelServices = t11;
  let t12;
  if ($[12] !== isHomePage || $[13] !== showBackButton) {
    t12 = showBackButton && <Suspense><BackButton isHomePage={isHomePage} /></Suspense>;
    $[12] = isHomePage;
    $[13] = showBackButton;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== showTravelServices) {
    t13 = showTravelServices && <TravelServicesMobileDrawer />;
    $[15] = showTravelServices;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = isSnappHotel && <SnappIrTravelServicesMobileDrawer />;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== customTitle || $[19] !== disableLogoURL || $[20] !== minimalLogo || $[21] !== showAppModeTitle || $[22] !== title) {
    t15 = showAppModeTitle ? <div className="text-headline-6 font-normal">{title}</div> : <><Logo minimalLogo={minimalLogo} disableURL={disableLogoURL} />{Boolean(customTitle) && <><div className="bg-outline-thin -ms-1 me-1 h-[32px] w-px lg:-ms-2 lg:me-0 lg:h-[40px]" /><div className="text-on-surface-medium-emphasis text-sm font-bold lg:text-base">{customTitle}</div></>}</>;
    $[18] = customTitle;
    $[19] = disableLogoURL;
    $[20] = minimalLogo;
    $[21] = showAppModeTitle;
    $[22] = title;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== showTravelServices) {
    t16 = showTravelServices && <TravelServicesDesktop />;
    $[24] = showTravelServices;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== showAgenciesButton) {
    t17 = showAgenciesButton && <AgenciesButton />;
    $[26] = showAgenciesButton;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = isSnappHotel && <SnappIrTravelServicesDesktop />;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t15 || $[32] !== t16 || $[33] !== t17) {
    t19 = <nav className="flex h-full items-center gap-2 lg:gap-4">{t12}{t13}{t14}{t15}{t16}{t17}{t18}</nav>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex-1" />;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== showMyTrips) {
    t21 = showMyTrips && <Suspense><MyTrips /></Suspense>;
    $[36] = showMyTrips;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== showSupportAgent) {
    t22 = showSupportAgent && <Suspense fallback={null}><SupportAgent /></Suspense>;
    $[38] = showSupportAgent;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = showAuth && <Suspense><HeaderLogin /></Suspense>;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t19 || $[42] !== t21 || $[43] !== t22) {
    t24 = <div className="mx-0 flex size-full items-center gap-2 lg:gap-4 xl:mx-auto xl:w-[1200px]">{t19}{t20}{t21}{t22}{t23}</div>;
    $[41] = t19;
    $[42] = t21;
    $[43] = t22;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Suspense><LoginModal /></Suspense>;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t24) {
    t26 = <div className="border-b-outline-thin relative z-30 flex h-16 w-full border-b bg-white px-4 lg:z-40 lg:px-6 xl:px-10">{t24}{t25}</div>;
    $[46] = t24;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  return t26;
};